import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ALL_PAGE_SEO_API, EMAIL_API, PHONE_API, SCRIPT_URL, TRACKORDER_API } from '../../config/config';
import Breadcrumb from '../../components/breadcrumbcomponents/Breadcrumb';
import imageBorder from "../../assets/images/bestsellerborder.webp";
import { Col, Container, Row, Form, Button, Modal } from 'react-bootstrap';
import partyname from "../../../src/assets/images/partyname.png";
import transport from "../../../src/assets/images/transport.png";
import state from "../../../src/assets/images/state.png";
import city from "../../../src/assets/images/city.png";
import village from "../../../src/assets/images/village.png";
import lrnumber from "../../../src/assets/images/lrnumber.png";
import lrdate from "../../../src/assets/images/lrdate.png";
import deliveryreceived from "../../../src/assets/images/delivery-received.png";
import attachment from "../../../src/assets/images/attachment.png";
import { Helmet } from 'react-helmet-async';



const TrackOrder = () => {
    const [trackingData, setTrackingData] = useState(null);
    const [error, setError] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState(null); // { type: 'image' | 'video', src: '...' }

    const handleOpenModal = (type, src) => {
        setModalContent({ type, src });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setModalContent(null);
    };

    const formik = useFormik({
        initialValues: {
            quotationNumber: '',
        },
        validationSchema: Yup.object({
            quotationNumber: Yup.string().required('Quotation number is required'),
        }),
        onSubmit: async (values) => {
            try {
                const response = await axios.post(`${TRACKORDER_API}`, {
                    quotation_number: values.quotationNumber,
                });

                if (response.data.status === '200') {
                    setTrackingData(response.data.deliverytracking);
                    setError('');
                } else {
                    setTrackingData(null);
                    setError('No data found.');
                }
            } catch (err) {
                setTrackingData(null);
                setError('Something went wrong.');
                console.error(err);
            }
        },
    });

    const [seoData, setSeoData] = useState([]);

    const seofetchData = async () => {
        try {
            const response = await axios.get(ALL_PAGE_SEO_API);
            if (response) {
                setSeoData(response.data.DATA[5].meta);
            } else {
                console.error("Unexpected API response structure:", response.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        seofetchData();
    }, []);

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>
                    {seoData?.meta_title ||
                        "Track Your Delivery: Kesaria Textile Company ~ Surat"}
                </title>
                <link
                    rel="canonical"
                    href={`${window.location.hostname == "localhost" ? "http" : "https"
                        }://${window.location.host}/track-your-delivery/`}
                />
                <link rel="publisher" href={`${SCRIPT_URL}`}></link>
                <meta
                    name="description"
                    content={
                        seoData?.meta_description ||
                        `Get connected to us & detail your current needs and what you may be interested in down the road. Our Sales Executive Number: ${PHONE_API} | ${EMAIL_API}`
                    }
                />
                <meta
                    name="keywords"
                    // content={"Leading Saree Manufacturers In Surat."}
                    content={
                        seoData?.meta_keyword ||
                        "Leading Saree Manufacturers In Surat."
                    }
                />
                <meta property="og:locale" content="en_US" />
                <meta
                    property="og:site_name"
                    content="Kesaria Textile Company | Fashion is King"
                />
                <meta
                    property="og:title"
                    content={
                        seoData?.meta_title ||
                        "Track Your Delivery: Kesaria Textile Company ~ Surat"
                    }
                />
                <meta property="og:type" content="article" />
                <meta
                    name="description"
                    property="og:description"
                    content={
                        seoData?.meta_description ||
                        `Get connected to us & detail your current needs and what you may be interested in down the road. Our Sales Executive Number: ${PHONE_API} | ${EMAIL_API}`
                    }
                />
                <meta
                    property="og:url"
                    content={`${window.location.hostname == "localhost" ? "http" : "https"
                        }://${window.location.host}/track-your-delivery/`}
                />
                <meta
                    property="article:published_time"
                    content="2015-12-26T03:36:03+00:00"
                />
                <meta
                    property="article:modified_time"
                    content="2024-05-22T08:25:01+00:00"
                />
                <meta name="twitter:card" content="summary" />
                <meta
                    name="twitter:title"
                    content={
                        seoData?.meta_title ||
                        "Track Your Delivery: Kesaria Textile Company ~ Surat"
                    }
                />
                <meta
                    name="twitter:description"
                    content={
                        seoData?.meta_description ||
                        `Get connected to us & detail your current needs and what you may be interested in down the road. Our Sales Executive Number: ${PHONE_API} | ${EMAIL_API}`
                    }
                />

                <script type="application/ld+json">
                    {`
                  {
                    "@context": "https://schema.org",
                    "@graph": [
                      {
                        "@type": "BreadcrumbList",
                        "@id": "${SCRIPT_URL}/track-your-delivery/",
                        "itemListElement": [
                          {
                            "@type": "ListItem",
                            "@id": "${SCRIPT_URL}",
                            "position": 1,
                            "name": "Home",
                            "item": "${SCRIPT_URL}",
                            "nextItem": "${SCRIPT_URL}/track-your-delivery/"
                          },
                          {
                            "@type": "ListItem",
                            "@id": "${SCRIPT_URL}/track-your-delivery/",
                            "position": 2,
                            "name": "Track Your Delivery",
                            "previousItem": "${SCRIPT_URL}"
                          }
                        ]
                      },
                      {
                        "@type": "Organization",
                        "@id": "${SCRIPT_URL}",
                        "name": "Keasria Textile Company",
                        "description": "Fashion is King",
                        "url": "${SCRIPT_URL}",
                        "logo": {
                          "@type": "ImageObject",
                          "url": "${SCRIPT_URL}/wp-content/uploads/2022/01/cropped-ktc-logo-1.png",
                          "@id": "${SCRIPT_URL}/track-your-delivery/",
                          "width": 512,
                          "height": 512,
                          "caption": "cropped-ktc-logo-1.png"
                        },
                        "image": {
                          "@id": "${SCRIPT_URL}/track-your-delivery/"
                        }
                      },
                      {
                        "@type": "WebPage",
                        "@id": "${SCRIPT_URL}/track-your-delivery/",
                        "url": "${SCRIPT_URL}/track-your-delivery/",
                        "name": "Track Your Delivery: Kesaria Textile Company ~ Surat",
                        "description": "Get connected to us & detail your current needs and what you may be interested in down the road. Our Sales Executive ${PHONE_API} | ${EMAIL_API}",
                        "inLanguage": "en-US",
                        "isPartOf": { "@id": "${SCRIPT_URL}" },
                        "breadcrumb": { "@id": "${SCRIPT_URL}/track-your-delivery/" },
                        "datePublished": "2015-12-26T09:06:03+05:30",
                        "dateModified": "2024-05-22T13:55:01+05:30"
                      },
                      {
                        "@type": "WebSite",
                        "@id": "${SCRIPT_URL}",
                        "url": "${SCRIPT_URL}",
                        "name": "Kesaria Textile Company",
                        "description": "Fashion is King",
                        "inLanguage": "en-US",
                        "publisher": { "@id": "${SCRIPT_URL}" }
                      }
                    ]
                  }
                  `}
                </script>
            </Helmet>

            <Breadcrumb
                breadcrumbTitle="Track Your Delivery"
                breadcrumbNav={[{ navText: "Home", path: "/" }]}
            />
            <Container>
                <div className="track-order container">
                    <div className="fw-normal text-center customer-rvw-h1 saree-heading pt-2">
                        Track Your Delivery
                    </div>
                    <div className="d-flex justify-content-center">
                        <img
                            src={imageBorder}
                            className="py-2 border-image"
                            alt="border"
                            loading="lazy"
                        />
                    </div>

                    <Row className='mt-4 mt-md-4 mt-lg-5 justify-content-center'>
                        <Col lg={5} md={7} sm={11}>
                            <Form onSubmit={formik.handleSubmit} noValidate>
                                <div className="search-box rounded-5">
                                    <div className='track-box-header d-flex align-items-center justify-content-center py-2 fs-5'>
                                        Track Your Delivery
                                    </div>

                                    <Form.Group className="px-4 pt-4 text-start">
                                        <Form.Label className='fw-medium fs-5' style={{ color: "black" }}>Quotation Number</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="quotationNumber"
                                            placeholder="Enter your quotation number"
                                            value={formik.values.quotationNumber}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            isInvalid={!!formik.errors.quotationNumber && formik.touched.quotationNumber}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    formik.handleSubmit();
                                                }
                                            }}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {formik.errors.quotationNumber}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <div className="text-center pt-3 pb-4">
                                        <button
                                            type="submit"
                                            className="btn-red-to-black-color-move mt-3 px-4 py-2 reachus-btn rounded-5"
                                        >
                                            <span className='px-3'>Search</span>
                                        </button>
                                    </div>
                                </div>
                            </Form>

                            {error && (
                                <div className="alert alert-danger mt-4 text-center">{error}</div>
                            )}
                        </Col>
                    </Row>

                    {trackingData && trackingData.length > 0 && (
                        <div className="px-2 px-lg-0">
                            <h4 className="mt-5 fs-4 fs-lg-1 text-start track-h1">Delivery Details</h4>
                            {trackingData.map((item) => (
                                <div className="result-box mt-3 mt-3 py-3 px-0 py-lg-4 px-lg-4  rounded-5 bg-white">
                                    <div key={item.id} className="">
                                        <div className="row gy-2">
                                            <div className="col-md-3">
                                                <div className="d-flex gap-2">
                                                    <div className="p-1 px-2">
                                                        <img src={partyname} alt="partyname.png" width={"40px"} loading="lazy" />
                                                    </div>
                                                    <div>
                                                        <div className="track-color">Party Name:</div>
                                                        <div className='track-sub-name'>{item.party_name}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="d-flex gap-2">
                                                    <div className="p-1 px-2">
                                                        <img src={transport} alt="transport" width={"40px"} loading="lazy" />
                                                    </div>
                                                    <div>
                                                        <div className="track-color">Transport:</div>
                                                        <div className='track-sub-name'>{item.transport_name}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="d-flex gap-2">
                                                    <div className="p-1 px-2">
                                                        <img src={state} alt="transport" width={"40px"} loading="lazy" />
                                                    </div>
                                                    <div>
                                                        <div className="track-color">State:</div>
                                                        <div className='track-sub-name'>{item.state}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="d-flex gap-2">
                                                    <div className="p-1 px-2">
                                                        <img src={city} alt="transport" width={"40px"} loading="lazy" />
                                                    </div>
                                                    <div>
                                                        <div className="track-color">City:</div>
                                                        <div className='track-sub-name'>{item.city}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="d-flex gap-2">
                                                    <div className="p-1 px-2">
                                                        <img src={village} alt="transport" width={"40px"} loading="lazy" />
                                                    </div>
                                                    <div>
                                                        <div className="track-color">Village:</div>
                                                        <div className='track-sub-name'>{item.village}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="d-flex gap-2">
                                                    <div className="p-1 px-2">
                                                        <img src={lrnumber} alt="transport" width={"40px"} loading="lazy" />
                                                    </div>
                                                    <div>
                                                        <div className="track-color">LR Number:</div>
                                                        <div className='track-sub-name'>{item.lr_number}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="d-flex gap-2">
                                                    <div className="p-1 px-2">
                                                        <img src={lrdate} alt="transport" width={"40px"} loading="lazy" />
                                                    </div>
                                                    <div>
                                                        <div className="track-color">LR Date:</div>
                                                        <div className='track-sub-name'>{item.lr_date}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="d-flex gap-2">
                                                    <div className="p-1 px-2">
                                                        <img src={deliveryreceived} alt="transport" width={"40px"} loading="lazy" />
                                                    </div>
                                                    <div>
                                                        <div className="track-color">Delivery Received:</div>
                                                        <div className='track-sub-name'>{item.delivery_received_date}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="d-flex gap-2">
                                                    <div className="p-1 px-2">
                                                        <img src={attachment} alt="transport" width={"40px"} loading="lazy" />
                                                    </div>
                                                    <div className='d-flex align-items-center'>
                                                        <div className="track-color">Attachment:</div>
                                                    </div>
                                                </div>
                                                {item.media_attachment ? (
                                                    (() => {
                                                        const ext = item.media_attachment.split('.').pop().toLowerCase();
                                                        if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) {
                                                            return (
                                                                <img
                                                                    src={item.media_attachment}
                                                                    alt="Attachment"
                                                                    className="img-fluid mt-2 rounded-5 track-video"
                                                                    style={{ maxWidth: '300px', cursor: 'pointer' }}
                                                                    onClick={() => handleOpenModal('image', item.media_attachment)}
                                                                    loading="lazy"
                                                                />
                                                            );
                                                        } else if (['mp4', 'webm', 'ogg'].includes(ext)) {
                                                            return (
                                                                <video
                                                                    controls
                                                                    src={item.media_attachment}
                                                                    className="img-fluid mt-2 rounded-5 track-video"
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => handleOpenModal('video', item.media_attachment)}
                                                                />
                                                            );
                                                        } else {
                                                            return <span className="text-muted">No attachment</span>;
                                                        }
                                                    })()
                                                ) : (
                                                    <span className="text-muted">No attachment</span>
                                                )}

                                                {/* Modal Popup */}
                                                <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
                                                    <Modal.Header closeButton className='py-1'>
                                                        <Modal.Title >
                                                            <div className="p-1 px-2">
                                                                <img src={attachment} alt="transport" width={"35px"} loading="lazy" />
                                                                <span className='px-2'>Attachment :</span>
                                                            </div>
                                                        </Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body className="text-center">
                                                        {modalContent ? (
                                                            modalContent.type === 'image' ? (
                                                                <img src={modalContent.src} alt="Full View" className="img-fluid rounded" loading="lazy" />
                                                            ) : (
                                                                <video
                                                                    src={modalContent.src}
                                                                    controls muted={false}
                                                                    className="img-fluid rounded w-100"
                                                                    style={{ maxHeight: '80vw' }}
                                                                />
                                                            )
                                                        ) : (
                                                            <p>Loading...</p>
                                                        )}
                                                    </Modal.Body>
                                                </Modal>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </Container>
        </>
    );
};

export default TrackOrder;
